<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.46 105.62">
    <path :fill="badgeColor" d="M88.93,20.02l-10.88,2.15-.87-4.35c-.48-2.4,1.08-4.74,3.49-5.22l2.18-.42,6.08,7.84ZM121.61,13.52l-1.73-8.7-8.72,1.73,6.08,7.86,4.37-.89ZM78.06,22.17v22.2c0,2.46,2,4.44,4.44,4.44h35.52c2.46,0,4.44-1.98,4.44-4.44v-22.2h-44.4ZM110.71,15.67l-6.08-7.84-4.37.87,6.1,7.84,4.35-.87ZM99.83,17.85l-6.08-7.88-4.37.91,6.1,7.84,4.35-.87Z" />
    <path :fill="iconColor" d="M110.89,63.37h0s-5.28,0-5.28,0c0-3.85-.59-7.57-1.68-11.06h-21.44c-4.38,0-7.94-3.56-7.94-7.94v-17.49c-1.91-.31-3.86-.47-5.85-.47-.02,0-.04,0-.06,0h-5.28v-6.7c5.05-2.92,6.78-9.38,3.87-14.43-2.92-5.05-9.38-6.78-14.43-3.87-5.05,2.92-6.78,9.38-3.87,14.43.93,1.61,2.26,2.94,3.87,3.87v6.7h-5.28c-20.4-.02-36.95,16.51-36.96,36.91v.06h-5.28c-2.91.01-5.27,2.37-5.28,5.28v15.84c.01,2.91,2.37,5.27,5.28,5.28h5.28v5.28c0,5.83,4.72,10.56,10.55,10.56h73.93c5.81.02,10.54-4.67,10.56-10.49,0-.02,0-.05,0-.07v-5.28h5.28c2.91-.01,5.27-2.37,5.28-5.28v-15.84c-.01-2.91-2.37-5.27-5.28-5.28ZM40.55,79.43l-6.23-6.23-6.23,6.23-6.23-6.23,12.46-12.46,12.46,12.46-6.23,6.23ZM88.08,79.43l-6.23-6.23-6.23,6.23-6.23-6.23,12.46-12.46,12.46,12.46-6.23,6.23Z" />
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: 'ai_film_maker'
      },
      iconColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.defaultIconColor }
      },
      badgeColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.primary }
      },
    }
  }
</script>
